<template>
  <div>
    <CRow>
      <CCol md="12">

                <CRow class="m-1">
                  <CCol col="3">
                    <date-picker
                        :label="$t('components.startDate')"
                        v-model="start_date"></date-picker>
                  </CCol>
                  <CCol col="3">
                    <date-picker
                        :label="$t('components.endDate')"
                        v-model="end_date"></date-picker>

                  </CCol>
                  <CCol col="2">
                    <CButton size="sm"  @click="get_all_data()" color="secondary">
                      {{$t('search')}}
                    </CButton>
                  </CCol>
                  <CCol col="2">
                    <CButton @click="validate_confirm()" type="submit" size="sm" color="secondary">
                      {{$t('acceptExitProducts')}}
                    </CButton>
                  </CCol>

                </CRow>


                <CDataTableFixed
                    :items="exit_delivery_product_inventory_items"
                    :fields="exit_factors_inventory_fields"
                    striped
                    @row-clicked="table_row_clicked"
height="300px"
                    :checkbox="true"
                    :checkbox_ids.sync="id_checkbox_items_delivery"
                    checkbox_key="recId"
                    sorter
                    border
                    column-filter
                    :items-per-page="200"
                    hover
                    pagination
                >
                  <template #select-header="{item}">
                    <input type="checkbox" v-model="check_all_exit_delivery"
                    />
                  </template>
                  <template #row_id="{item,index}">

                    <td style="text-align: center">
                      <p >{{ index + 1 }}</p>

                    </td>

                  </template>
                  <template #createdAt="{item}">

                    <td>
                      <p >{{ item.createdAt }}</p>

                    </td>

                  </template>
                  <template #toziKonande="{item}">

                    <td>
                      <p v-if="item.toziKonande" >{{ item.toziKonande }}</p>
                      <p v-else >{{$t('driverNotFound')}}</p>

                    </td>

                  </template>
                  <template #masterCode="{item}">

                    <td class="text-center">
                      <a href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item)">
                        {{ item.masterCode }}
                      </a>
                    </td>

                  </template>
                  <template #routeName="{item}">

                    <td>
                      <p v-if="item.routeName" >{{ item.routeName }}</p>
                      <p v-else > {{$t('routeNotFound')}}</p>

                    </td>

                  </template>

                  <template #partyName="{item}">

                    <td>
                      <p >{{ item.partyName }} {{ item.surName }}</p>

                    </td>

                  </template>
                  <template #operation="{item}">
                    <td>

                      <CButton
                          class="m-1"
                          color="primary"
                          variant="outline"
                          square
                          :title="$t('buttons.show')"
                          size="sm"
                          @click="goShowDocument(item)"
                      >
                        <CIcon name="cil-speedometer"/>
                      </CButton>


                    </td>
                  </template>
                  <template #select="{item}">
                    <td>

                      <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items_delivery"
                             :value="item.recId"/>


                    </td>
                  </template>
                </CDataTableFixed>



    <CModal
            :show.sync="show_factor_detail"
            :no-close-on-backdrop="true"
            :centered="true"
            :title="$t('InventoryBill')"
            size="lg"
            color="dark"
    >
      <CCard>
        <CCardHeader>
          <strong>{{ $t('components.documentsList') }}</strong>

        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol col="3">{{ $t('BaseInvoiceNo') }} : {{ selected_factor.masterCode }}</CCol>
            <CCol col="6">{{ $t('customer') }} : {{selected_factor.partyCode}} {{ selected_factor.partyName }}</CCol>
            <CCol col="3">{{ $t('tables.date') }} : {{ get_date(selected_factor.docDate) }}</CCol>
            <CCol col="3">{{ $t('inventory') }} : {{ selected_factor.placeName }}</CCol>

          </CRow>

          <CDataTableFixed
                  :items="selected_factor_detail"
                  :fields="factor_product_fields"
                  striped
                  height="200px"
sorter
                  border
                  :items-per-page="200"
                  hover
                  pagination
          >
            <template #row="{item,index}">

              <td>
                <p style="text-align: center">{{ index + 1 }}</p>

              </td>
            </template>

            <template #name="{item}">

              <td>
                <p>{{ item.productCode }} {{ item.productName }}</p>

              </td>

            </template>

            <template #qty="{item}">
              <td>
                <p style="text-align: center">{{ Math.abs(item.qty) }}</p>
              </td>
            </template>

            <template #price="{item}">
              <td>
                <p style="text-align: right">{{ get_currency(item.price) }}</p>
              </td>
            </template>

            <template #discount="{item}">
              <td>
                <p style="text-align: right">{{ item.discount }}</p>
              </td>
            </template>

            <template #tax="{item}">
              <td>
                <p style="text-align: right">{{ item.tax }}</p>
              </td>
            </template>
            <template #totalPrice="{item}">

              <td>
                <p style="float: right">{{ get_currency(Math.abs(item.totalPrice)) }} </p>

              </td>

            </template>

            <template #summary="{item}">

              <td>
                <strong>{{ item.summary }}</strong>

              </td>

            </template>

            <template #under-table="{item}">
              <CRow>
                <CCol></CCol>
                <CCol></CCol>
                <CCol></CCol>
                <CCol>
                  {{ $t('totalCirculation') }} {{ currency_with_symbol(Math.abs(calculate_items(selected_factor_detail, "totalPrice")) ) }}
                </CCol>
                <CCol></CCol>
              </CRow>
            </template>


          </CDataTableFixed>


        </CCardBody>

      </CCard>


      <template #footer>
        <CButton
                @click="show_factor_detail = false"
                color="success"
        >{{ $t("buttons.close") }}
        </CButton>
      </template>
    </CModal>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];
export default {
  name: 'Login',
  components: {

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      table_clicks:0,
      table_clicks_timer:null,
      show_factor_detail: false,
      start_date: '',
      end_date: '',
      selected_factor_detail:[],
      selected_factor: {},
      change_status_modal: false,
      exit_delivery_product_inventory_items: [],
      exit_factors_inventory_fields: [

        {key: 'row_id', label: this.$t('tables.number'), _style: 'width:2%'},
        {key: 'masterCode', label: this.$t('tables.factorId'), _style: 'width:5%'},
        // {key: 'price', label: this.$t('tables.price'), _style: 'width:10%'},
        {key: 'partyName', label: this.$t('customer'), _style: 'width:10%'},
        {key: 'placeName',label: this.$t('inventory'), _style: 'width:10%'},
        {key: 'toziKonande',label: this.$t('driver'), _style: 'width:10%'},
        {key: 'routeName',label: this.$t('route'), _style: 'width:10%'},

        // {key: 'user', label: this.$t('tables.user'), _style: 'width:15%'},
        // {key: 'status', label: this.$t('DisabilityStatus'), _style: 'width:15%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
        // {key: 'select', label: this.$t('tables.select'), _style: 'width:2%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
      factor_product_fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'name', label: this.$t('components.productName'), _style: 'width:20%'},
        // {key: 'placeName', label: this.$t('sidebars.inventory') , _style: 'width:15%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%'},
        {key: 'price', label: this.$t('components.unitPrice'), _style: 'width:10%'},
        {key: 'discount', label: this.$t('tables.off'), _style: 'width:10%'},
        {key: 'tax', label: this.$t('vat'), _style: 'width:10%'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'width:10%'},
        {key: 'summary', label: this.$t('tables.summary'), _style: 'width:15%'},
      ],
      id_checkbox_items_delivery: [],
      check_all_exit_delivery: false,

    }
  },
  mounted() {

    this.start_date = this.get_today();
    this.end_date = this.get_today();


    this.get_all_data();
    bus.$on('accept_confirm_factor' + this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.accept_delivery_lists();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {

    // 'start_date': function () {
    //   this.get_all_data();
    // },
    // 'end_date': function () {
    //   this.get_all_data();
    // },
    'check_all_exit_delivery': function () {
      if (this.check_all_exit_delivery) {
        this.id_checkbox_items_delivery = [];

        this.exit_delivery_product_inventory_items.forEach((val) => {
          this.id_checkbox_items_delivery.push(val.recId);
        });
      } else {
        this.id_checkbox_items_delivery = [];
      }
    }
  },
  methods: {
    goToDocuments(item) {
      window.open('/dashboard/documents/show/' + item.recId)
      // this.$router.push({path: '/dashboard/documents/show/' + item.recId});

    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 300);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        // this.goShowDocument(item)
        this.table_clicks = 0
        this.get_document_details(item);

      }

    },
    get_document_details(item_doc) {
      var self = this;

      // this.id_checkbox_items = [];
      const formData = new FormData();

      var url = "GetDocItemsByDocId";
      self.selected_factor = item_doc
      self.selected_factor_id = item_doc.recId
      formData.append("id", item_doc.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.show_factor_detail = true;
          // this.status_form = item.masterId;
          self.selected_factor_detail = content_data.data;
          self.selected_factor_detail.forEach(function (val){
            val.TotalPrice = parseFloat(val.price)*parseFloat(val.qty)
          })
// console.log("products is",self.selected_factor_detail)
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
              .catch(function (error) {
                console.log(error);
              });

    },

    get_all_data(){
      this.get_delivery_lists()
    },

    get_delivery_lists() {
      var self = this;

      const formData = new FormData();

      formData.append('FirstDate', this.start_date);
      formData.append('SecondDate', this.end_date);
      formData.append('DocType', 3);
      formData.append('DeliveryType', 21);


      axios.post('GetDocsByForDelivery', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.exit_delivery_product_inventory_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    validate_confirm(){
      if (this.id_checkbox_items_delivery.length == 0) {
        this.$root.modal_component.show_validate_errors([this.$t('selectOne')])
        return false;
      }
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("sureToConfirm") , [this.$t("dialogs.ok")], 'accept_confirm_factor' + this.confirm_delete_name);

    },
    accept_delivery_lists() {
      var self = this;

      const formData = new FormData();
this.id_checkbox_items_delivery.forEach(function (val) {
  formData.append('Factors[]', val);

})
      // formData.append('SecondDate', this.end_date);
      // formData.append('DocType', 3);
      // formData.append('DeliveryType', 21);


      axios.post('AcceptFactorLoadingPlatform', formData, {}).then(function (response) {

        var content_data = response.data;
        self.$root.modal_component.show_api_response_modals(response);
        self.get_all_data()
        self.id_checkbox_items_delivery = []
        bus.$emit('platform_updated',true)
        // items = content_cats.orders;
        // if (content_data.statusCode == 0) {
        //
        // } else {
        //   self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        //
        // }


      })
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
